import type { ClassicEditor } from "ckeditor5";

let ckeditor: ClassicEditor | null = null;

export const getCkeditor = () => {
  if (!ckeditor) {
    throw new Error("ckeditor is not set yet");
  }
  return ckeditor;
};
export const setCkeditor = (editor: null | ClassicEditor) => {
  ckeditor = editor;
};
